import React from 'react'
import { toast } from 'react-toastify'

// Styles
import './styles.scss'

// Icons
import IconClose from './images/iconClose'
import IconError from '../../containers/ProfilePage/images/iconError'

export default (
  icon: JSX.Element | string,
  title: string,
  description: string,
  onOpen?: () => void,
  onClose?: () => void,
  onClick?: () => void,
  toastId?: string
) => {
  const FormatIcon = () => {
    if (typeof icon === 'string') {
      switch (icon) {
        case 'error':
          return <IconError width={113} height={113} />
        default:
          return <img src={icon} />
      }
    } else {
      return icon
    }
  }

  toast(
    <div className={'notification'}>
      <div className={'notification__outer'} onClick={onClick}>
        <FormatIcon />
        <div className={'notification__outer-content'}>
          <div className={'notification__outer-content-title'}>{title}</div>
          <div className={'notification__outer-content-description'}>
            {description}
          </div>
        </div>
      </div>
      <div className={'notification__close'}>
        <IconClose
          onClick={() => (toastId ? toast.dismiss(toastId) : toast.dismiss())}
        />
      </div>
    </div>,
    {
      toastId,
      onOpen,
      onClose,
    }
  )
}
